 

const iconName = 'modalExclamation';
const width = 33;
const height = 34;
const svgPathData =
	'M16.203.134c1.478 0 2.844.79 3.582 2.071l11.342 19.622a4.134 4.134 0 01-3.58 6.2H4.864a4.134 4.134 0 01-3.585-6.2L12.62 2.205a4.134 4.134 0 013.583-2.07zm.006 3.15a.983.983 0 00-.854.497L4.013 23.403a.983.983 0 00.85 1.474h22.672a.964.964 0 00.851-.491.964.964 0 00.019-.983L17.063 3.78a.983.983 0 00-.854-.496zm-.003 16.483c.865 0 1.568.698 1.575 1.563v.094a1.575 1.575 0 11-3.15 0v-.082c0-.87.705-1.575 1.575-1.575zm0-10.813c.87 0 1.575.705 1.575 1.575V16.2a1.575 1.575 0 01-3.15 0v-5.67c0-.87.705-1.576 1.575-1.576z';

export default {
	iconName: iconName,
	icon: [width, height, svgPathData],
};


